/*
 * GONE.ARCHIVE (07.09) — przywracanie pozycji scrolla na kolekcjach z infinity scroll.
 * Plik WLASNY: aktualizacja motywu Etheryx go nie nadpisze. Wpiecie: sections/t-collection.liquid
 * (tylko przy mode == 'infinity').
 *
 * Problem: infinity scroll dokleja kolejne strony przez fetch (assets/c-infinityscroll.js),
 * wiec po wejsciu w produkt i cofnieciu przegladarka renderuje od nowa TYLKO strone 1 -
 * natywne przywracanie scrolla nie ma czego przywrocic (strona jest za krotka).
 * Wyjatek: powrot z bfcache zachowuje caly DOM i pozycje - wtedy nic nie robimy
 * (pageshow.persisted == true).
 *
 * Mechanizm:
 *   1. Przy opuszczaniu strony (pagehide) zapisujemy do sessionStorage, per adres kolekcji:
 *      liczbe zaladowanych kart i pozycje scrolla.
 *   2. Przy powrocie (zwykly load, nie bfcache) wolamy loadNextPage() komponentu dostawcy,
 *      az liczba kart dogoni zapisana (limit bezpieczenstwa 60 stron), po czym scrollTo.
 *   3. sessionStorage jest per karta przegladarki i znika po jej zamknieciu - swiezo otwarta
 *      kolekcja zawsze startuje od gory. Wpis wygasa po 30 minutach.
 */
(function () {
  'use strict';

  var KEY = 'ga-inf-scroll:' + location.pathname;
  var MAX_PAGES = 60;
  var TTL_MS = 30 * 60 * 1000;

  function read() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return null;
      var s = JSON.parse(raw);
      if (!s || Date.now() - s.t > TTL_MS) return null;
      return s;
    } catch (e) { return null; }
  }

  function save() {
    try {
      var inf = document.querySelector('infinity-scroll');
      var items = inf && inf.querySelector('#ajaxContainer');
      if (!items) return;
      sessionStorage.setItem(KEY, JSON.stringify({
        n: items.children.length,
        y: window.scrollY,
        t: Date.now()
      }));
    } catch (e) { /* sessionStorage niedostepny - trudno */ }
  }

  var restoredFromBfcache = false;
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) restoredFromBfcache = true; // bfcache: DOM i scroll juz sa
  });
  window.addEventListener('pagehide', save);

  async function restore() {
    if (restoredFromBfcache) return;
    var state = read();
    if (!state || state.n <= 0) return;

    var inf = document.querySelector('infinity-scroll');
    var items = inf && inf.querySelector('#ajaxContainer');
    if (!inf || !items || typeof inf.loadNextPage !== 'function') return;
    if (items.children.length >= state.n) {
      window.scrollTo(0, state.y);
      return;
    }

    var guard = 0;
    while (items.children.length < state.n && guard < MAX_PAGES) {
      var link = inf.querySelector('#ajaxPagination a');
      if (!link) break; // nie ma kolejnych stron
      await inf.loadNextPage();
      guard++;
    }
    window.scrollTo(0, state.y);
  }

  function ready() {
    // customElements: komponent dostawcy musi byc zdefiniowany, zanim zawolamy loadNextPage
    var wait = window.customElements && customElements.whenDefined
      ? customElements.whenDefined('infinity-scroll')
      : Promise.resolve();
    wait.then(restore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();
